import { BUTTONS } from 'wix-rich-content-plugin-commons';
import { getModalStyles, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import GiphyInsertModal from './giphyInsertModal.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DESKTOP_FLY_OUT_MODAL_STYLES } from '../constants.js';
import MediaReplaceIcon from '../icons/MediaReplaceIcon.js';
import 'react';
import '../giphyApiInputModal-41baafe8.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import './giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import '../giphyEmptyState-aa3b5112.js';
import '../icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInlineButtons = ({
  t,
  settings,
  isMobile
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.replace) || MediaReplaceIcon;
  const modalStyles = isMobile ? getModalStyles({ customStyles: MOBILE_FULL_SCREEN_CUSTOM_STYLE, fullScreen: true, isMobile }) : void 0;
  return [
    { keyName: "sizeOriginal", type: BUTTONS.SIZE_ORIGINAL, mobile: false },
    { keyName: "sizeSmallCenter", type: BUTTONS.SIZE_SMALL_CENTER, mobile: false },
    { keyName: "sizeContent", type: BUTTONS.SIZE_CONTENT, mobile: false },
    { keyName: "sizeFullWidth", type: BUTTONS.SIZE_FULL_WIDTH, mobile: false },
    { keyName: "separator1", type: BUTTONS.SEPARATOR, mobile: false },
    { keyName: "sizeSmallLeft", type: BUTTONS.SIZE_SMALL_LEFT, mobile: false },
    { keyName: "sizeSimallRight", type: BUTTONS.SIZE_SMALL_RIGHT, mobile: false },
    { keyName: "separator2", type: BUTTONS.SEPARATOR, mobile: false },
    {
      keyName: "replace",
      type: BUTTONS.EXTERNAL_MODAL,
      icon,
      modalElement: decorateComponentWithProps(GiphyInsertModal, settings),
      modalStyles,
      modalStylesFn: ({ buttonRef }) => {
        const modalStyles2 = getModalStyles({
          customStyles: DESKTOP_FLY_OUT_MODAL_STYLES,
          fullScreen: true,
          isMobile
        });
        const { top, left } = buttonRef.getBoundingClientRect();
        const modalLeft = left - 15;
        const modalTop = top > 357 ? top - 365 : top + 30;
        return __spreadProps(__spreadValues({}, modalStyles2), {
          content: __spreadProps(__spreadValues({}, modalStyles2.content), {
            top: modalTop,
            left: modalLeft,
            margin: 0,
            position: "absolute"
          })
        });
      },
      mobile: true,
      tooltipTextKey: "ReplaceGiphyButton_Tooltip",
      t
    },
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
